// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"f93b377a","308":"af614b75","316":"19b76053","562":"1bdd4bfb","670":"5ebf6797","787":"cb623dd8"}[chunkId] + ".chunk.js";
};